// extracted by mini-css-extract-plugin
export default {"Box":"ReferencedEvent-module__Box__KseiLXC"};